import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const panOs = defineConnector({
  identifier: "panOs",
  name: "PAN-OS",
  tagLine: "Palo Alto Networks firewall management",
  logo,
  protocol: "http",
  tags: ["security"],
  auth: (app) => headerAuth([{ name: "X-PAN-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Generate an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your PAN-OS firewall or Panorama web interface, go to the **XML API** and generate an API key by making a keygen request, or retrieve an existing key from **Device > Administrators**.",
        },
      ],
    },
    {
      title: "Enter your firewall details",
      items: [
        {
          kind: "hostname",
          label: "Firewall host",
          placeholder: "firewall.your-org.com",
          required: true,
          target: { kind: "configuration", field: "firewallHost" },
          helperText:
            "The hostname or IP address of your PAN-OS firewall or Panorama.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ firewallHost }) => domainToRegex(firewallHost),
  connectionTest: {
    protocol: "http",
    request: ({ firewallHost }) =>
      `https://${firewallHost}/restapi/v10.2/System/SystemInfo`,
  },
});
